import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferrerFromSearch } from "utils/referrerCookie";
import { captureCampaignSourceFromLocation } from "utils/registration";
import { captureReferralFromLocation } from "utils/referral";

/** Sets referrer / campaign / referral cookies from landing query params. */
const ReferrerCapture = () => {
  const location = useLocation();

  useEffect(() => {
    captureReferrerFromSearch(location.search);
    captureCampaignSourceFromLocation(location);
    captureReferralFromLocation(location);
  }, [location]);

  return null;
};

export default ReferrerCapture;
